
<div class="c-card">
  <div class="c-card__border-top" />
  <div class="c-card__content">
    <slot />
  </div>
</div>
